import { BlogComponentType } from '../types'

export const iconNames = [
  'arrow-down-small',
  'arrow-left',
  'arrow-right',
  'check',
  'close',
  'command-line',
  'copy',
  'copy-document',
  'download',
  'duotone-align',
  'duotone-feather',
  'duotone-creditcard',
  'duotone-hand',
  'duotone-heart',
  'duotone-help',
  'duotone-support',
  'file-pdf',
  'filter',
  'folder-watched',
  'link-external',
  'login',
  'logout',
  'list',
  'help',
  'logo-angular',
  'logo-apple',
  'logo-electron',
  'logo-facebook',
  'logo-instagram',
  'logo-linkedin',
  'logo-next',
  'logo-nuxt',
  'logo-pwa',
  'logo-react',
  'logo-ruby',
  'logo-svelte',
  'logo-twitter',
  'logo-discord',
  'logo-typescript',
  'logo-vue',
  'logo-windows',
  'logo-xing',
  'mail',
  'mail-plane',
  'menu',
  'minus',
  'plus',
  'refresh',
  'quotes',
  'sales',
  'search',
  'spark',
  'world',
] as const

export const operationSystems = [

  {
    "name": "MacOS",
    "created_at": "2023-03-23T15:58:31.213Z",
    "published_at": "2023-08-29T12:31:27.950Z",
    "id": 280930062,
    "uuid": "c4e4a9b7-14a4-4733-a3bd-3b47d9d65e0d",
    "content": {
      "_uid": "98b95bde-aaee-4d4f-b3d8-68835b2bd6f9",
      "icon": "icon-macos",
      "name": "MacOS",
      "component": "OperationSystem"
    },
    "slug": "macos",
    "full_slug": "data/operation-systems/macos",
    "sort_by_date": null,
    "position": -30,
    "tag_list": [],
    "is_startpage": false,
    "parent_id": 280925224,
    "meta_data": null,
    "group_id": "e25ac67e-9744-4f88-8e73-87556adc0057",
    "first_published_at": "2022-09-15T10:11:21.875Z",
    "release_id": null,
    "lang": "default",
    "path": null,
    "alternates": [],
    "default_full_slug": "data/operation-systems/macos",
    "translated_slugs": [
      {
        "path": "data/operation-systems/macos",
        "name": null,
        "lang": "fr",
        "published": null
      },
      {
        "path": "data/operation-systems/macos",
        "name": null,
        "lang": "de",
        "published": null
      }
    ],
    "_stopResolving": true
  },
  {
    "name": "Windows Client",
    "created_at": "2023-03-23T15:59:04.550Z",
    "published_at": "2023-08-29T12:32:03.566Z",
    "id": 280931157,
    "uuid": "dd0d2d16-d77c-4882-b991-319be6be03a1",
    "content": {
      "_uid": "a067f2e1-8d55-498f-8c79-c2d9a372d4d6",
      "icon": "icon-windows-client",
      "name": "Windows Client",
      "component": "OperationSystem"
    },
    "slug": "windows-client",
    "full_slug": "data/operation-systems/windows-client",
    "sort_by_date": null,
    "position": -10,
    "tag_list": [],
    "is_startpage": false,
    "parent_id": 280925224,
    "meta_data": null,
    "group_id": "4a25beb8-f8cd-4099-a409-fbd511fb5f9d",
    "first_published_at": "2022-09-15T10:11:05.843Z",
    "release_id": null,
    "lang": "default",
    "path": null,
    "alternates": [],
    "default_full_slug": "data/operation-systems/windows-client",
    "translated_slugs": [
      {
        "path": "data/operation-systems/windows-client",
        "name": null,
        "lang": "fr",
        "published": null
      },
      {
        "path": "data/operation-systems/windows-client",
        "name": null,
        "lang": "de",
        "published": null
      }
    ],
    "_stopResolving": true
  },
  {
    "name": "Linux",
    "created_at": "2023-03-23T15:58:52.473Z",
    "published_at": "2023-08-29T12:31:49.384Z",
    "id": 280930651,
    "uuid": "8f3b52e9-5066-49aa-a61f-16293a3faec2",
    "content": {
      "_uid": "860b2161-3059-4997-ab4d-4d62515536e3",
      "icon": "icon-linux",
      "name": "Linux",
      "component": "OperationSystem"
    },
    "slug": "linux",
    "full_slug": "data/operation-systems/linux",
    "sort_by_date": null,
    "position": -20,
    "tag_list": [],
    "is_startpage": false,
    "parent_id": 280925224,
    "meta_data": null,
    "group_id": "0c090445-9412-4b11-8a44-fe04342ff5a8",
    "first_published_at": "2022-09-15T10:10:47.102Z",
    "release_id": null,
    "lang": "default",
    "path": null,
    "alternates": [],
    "default_full_slug": "data/operation-systems/linux",
    "translated_slugs": [
      {
        "path": "data/operation-systems/linux",
        "name": null,
        "lang": "fr",
        "published": null
      },
      {
        "path": "data/operation-systems/linux",
        "name": null,
        "lang": "de",
        "published": null
      }
    ],
    "_stopResolving": true
  },
]
export const themes = [
  'azure',
  'bluetiful',
  'electric-indigo',
  'fuchsia',
  'limegreen',
  'magenta',
  'orange',
  'red',
  'turquoise',
  'yellow',
  'white',
  'black',
  'none',
] as const


export type IconName = typeof iconNames[number]
export type ThemeName = typeof themes[number]

export const productShortCodes = [
  { name: 'Conversion Service', value: '_CONVSRV' },
  { name: 'Pdf Tools SDK', value: '_PDFSDK' },
  { name: 'PDF Printer', value: '_PRN' },
  { name: 'PDF Analysis & Repair', value: '_REP' },
  { name: 'PDF Web Viewer', value: '_VIEWWEB' },
  // { name: 'PDF Extract', value: '_EXP' },
  // { name: 'Toolbox SDK', value: '_TOOLSDK' },
  // { name: 'PDF Optimizer', value: '_POL' },
  // { name: 'Image to PDF Converter', value: '_I2P' },
  // { name: 'PDF Merge Split', value: '_MSP' },
  // { name: 'PDF Security', value: '_SEC' },
  // { name: 'PDF to Image Converter', value: '_P2I' },
  // { name: 'PDF to PDF/A converter', value: '_CNV' },
  // { name: 'PDF Validator', value: '_VAL' },
]

export const productCategoryMap = {
  pdf_to_image_converter: 'conversion',
  pdf_to_pdf_a_converter: 'conversion',
  pdf_optimizer: 'conversion',
  image_to_pdf_converter: 'conversion',
  conversion_service: 'conversion',
  pdf_toolbox_sdk: 'manipulation',
  pdf_merge_split: 'manipulation',
  pdf_extract: 'manipulation',
  pdf_validator: 'validation_repair',
  pdf_analysis_repair: 'validation_repair',
  pdf_security: 'validation_repair',
  pdf_printer: 'viewing_printing',
  pdf_web_viewer: 'viewing_printing',
  pdf_viewing_sdk: 'viewing_printing',
}

export const componentCategoryMap: { [key in BlogComponentType]: string } = {
  [BlogComponentType.CUSTOMER_STORIES]: 'Customer stories',
  [BlogComponentType.USE_CASE]: 'Use cases',
  [BlogComponentType.COMPANY_INSIGHTS]: 'Company insights',
  [BlogComponentType.PRODUCT_NEWS]: 'Product news',
  [BlogComponentType.PDF_KNOWLEDGE]: 'Pdf knowledge',
}
